module.exports = __webpack_public_path__ + "img/edoge.77b7b1ce.svg";